export * from './StrapiBrandsWidget'
